import { useLang } from '@/i18n/LanguageContext';

interface ChipProps {
  name: string;
  src: string;
}

function LogoChip({ name, src }: ChipProps) {
  return (
    <div className="lchip">
      <div className="lchip-card">
        <img src={src} alt={name} />
      </div>
      <span className="lchip-name">{name}</span>
    </div>
  );
}

const LOGOS: ChipProps[] = [
  { name: 'Gmail', src: '/logos/Gmail.svg' },
  { name: 'Outlook', src: '/logos/Outlook.svg' },
  { name: 'Slack', src: '/logos/Slack.svg' },
  { name: 'WhatsApp', src: '/logos/WhatsApp.svg' },
  { name: 'Salesforce', src: '/logos/Salesforce.svg' },
  { name: 'HubSpot', src: '/logos/Hubspot.svg' },
  { name: 'Notion', src: '/logos/Notion.svg' },
  { name: 'Gong', src: '/logos/Gong.svg' },
];

export default function IntegrationStrip() {
  const { t } = useLang();
  return (
    <section className="section section--tight" style={{ paddingTop: 'clamp(56px,6vw,80px)' }}>
      <div className="container reveal">
        <div className="lstrip-head">
          <span className="lbl">{t('strip.label')}</span>
        </div>
        <div className="lstrip-row">
          {LOGOS.map((logo) => (
            <LogoChip key={logo.name} {...logo} />
          ))}
        </div>
      </div>
    </section>
  );
}
